// Share row: native share where available, copy link, social links. See snippets/share-button.liquid.
if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      connectedCallback() {
        this.urlToShare = this.dataset.url || document.location.href;
        this.message = this.querySelector('[data-share-message]');
        const native = this.querySelector('[data-share-native]');
        if (native && navigator.share) {
          native.hidden = false;
          native.addEventListener('click', () => navigator.share({ url: this.urlToShare, title: document.title }).catch(() => {}));
        }
        this.querySelector('[data-share-copy]')?.addEventListener('click', () => this.copy());
      }

      async copy() {
        try {
          await navigator.clipboard.writeText(this.urlToShare);
          if (this.message) {
            this.message.textContent = window.accessibilityStrings?.shareSuccess || 'Link copied';
            clearTimeout(this.timer);
            this.timer = setTimeout(() => (this.message.textContent = ''), 2500);
          }
        } catch (e) {}
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.dataset.url = url;
        this.querySelectorAll('a[href]').forEach((a) => {
          a.href = a.href.replace(/(u|url)=[^&]*/, (m, key) => `${key}=${encodeURIComponent(url)}`);
        });
      }
    }
  );
}
